













import Loading from '@/components/Base/Loading.vue'
import Footer from '@/components/Base/Footer.vue'
// import Guide from '@/components/Base/Guide.vue'
import TopWelfare from '@/components/Modules/TopWelfare.vue'
import Daily from '@/components/Modules/Daily.vue'
import { localStorage, getUserAgent } from '@tencent/midas-util'
import getConfig from '@/api/data'
import * as handler from '@/api/handler'

import mixins from 'vue-typed-mixins'
import pageMixin from '@/components/Mixins/page'
import linkAdsMixin from '@/components/Mixins/linkAds'

const Key = 'Midas_welfare_user_guide'

export default mixins(pageMixin, linkAdsMixin).extend({
  data() {
    return {
      config: {} as DisplayConfig,
      inActivity: false,
      showLoading: true
    }
  },

  components: {
    Loading,
    TopWelfare,
    Daily,
    Footer
    // Guide
  },

  // 判断用户是否是新用户，新用户显示新手指导
  created() {
    if (!localStorage.get(Key) && getUserAgent().android) {
      localStorage.set(Key, true)
    }
  },

  async mounted() {
    this.config = await getConfig()

    const currentActivity = handler.getMinimumTimeActivity(this.config.friday.itemList)
    this.inActivity = this.checkInActivity(currentActivity)

    this.$nextTick(() => {
      this.showLoading = false
    })

    this.logPageView('activity')
  }
})
